module.exports = __webpack_public_path__ + "static/media/icon_rotate_left.e45d5189.svg";